module.exports = __webpack_public_path__ + "static/media/Map_svg.8d1c8360.svg";